import { loadDismissablePrompts } from '@ms/yammer-data/dist/domains/dismissablePrompts/actions';
import { DismissablePromptType } from '@ms/yammer-data/dist/state/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export type UseLoadDismissablePromptsByType = (promptTypes: DismissablePromptType[]) => void;
export const useLoadDismissablePromptsByType: UseLoadDismissablePromptsByType = (promptTypes) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadDismissablePrompts({ promptTypes }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, ...promptTypes]);
};
